// src/pages/HomePage.js
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import SearchBar from '../components/SearchBar';
import NewStockSection from '../components/NewStockSection';
import TagSuggestions from '../components/TagSuggestions';
import CategorySongsSection from '../components/CategorySongsSection';
import SearchResultsSection from '../components/SearchResultsSection';

const PageContainer = styled.div`
  max-width: 100%;
  overflow-x: hidden;
  background-color: #E3E3E3;
  min-height: 100vh;
  border-radius: 12px;
`;

const ContentContainer = styled.div`
  width: 75%;
  margin: 0 auto;
  max-width: 100%;
  box-sizing: border-box;
  border-radius: 12px;
  overflow: hidden;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SectionContainer = styled.div`
  position: relative;
  min-height: 200px; /* Ensure container has height even when empty */
`;

function HomePage() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState(null);
  const [isNewStockVisible, setIsNewStockVisible] = useState(true);

  const handleTagClick = (tag) => {
    // Start fade out of current section
    setIsNewStockVisible(false);
    
    // After fade out, show CategorySongsSection
    setTimeout(() => {
      setSelectedCategory(tag);
      setSearchQuery(null); // Clear any search results
    }, 300); // Match the transition duration
  };

  const handleSearch = (query) => {
    // Start fade out of current section
    setIsNewStockVisible(false);
    
    // After fade out, show SearchResultsSection
    setTimeout(() => {
      setSearchQuery(query);
      setSelectedCategory(null); // Clear any category selection
    }, 300); // Match the transition duration
  };

  return (
    <PageContainer>
      <Helmet>
        <title>Tempo Stock | Royalty Free Music</title>
        <meta name="description" content="Find high quality royalty-free music for your projects on Tempo Stock." />
        <meta property="og:title" content="Tempo Stock | Royalty Free Music" />
        <meta property="og:description" content="Find high quality royalty-free music for your projects on Tempo Stock." />
        <meta name="twitter:title" content="Tempo Stock | Royalty Free Music" />
        <meta name="twitter:description" content="Find high quality royalty-free music for your projects on Tempo Stock." />
      </Helmet>
      <ContentContainer>
        <SearchBar onSearch={handleSearch} />
        <TagSuggestions onTagClick={handleTagClick} />
        <SectionContainer>
          {((!selectedCategory && !searchQuery) || isNewStockVisible) && (
            <NewStockSection visible={isNewStockVisible} />
          )}
          {selectedCategory && (
            <CategorySongsSection 
              category={selectedCategory} 
              visible={!isNewStockVisible} 
            />
          )}
          {searchQuery && (
            <SearchResultsSection 
              searchQuery={searchQuery} 
              visible={!isNewStockVisible} 
            />
          )}
        </SectionContainer>
      </ContentContainer>
    </PageContainer>
  );
}

export default HomePage;